import React from 'react';
import PropTypes from 'prop-types';
import NewOrderFormOne from './NewOrderFormOne';
import NewOrderFormTwo from './NewOrderFormTwo';
import NewOrderFormThree from './NewOrderFormThree';
import NewOrderFormFour from './NewOrderFormFour';
import NewOrderFormFive from './NewOrderFormFive';

export default class CreateNewOrderForm extends React.Component {
  static propTypes = {
    account: PropTypes.object.isRequired,
    accountId: PropTypes.number.isRequired,
    accountSettings: PropTypes.object.isRequired,
    addToListFunction: PropTypes.func.isRequired,
    cancelOrderFunction: PropTypes.func.isRequired,
    change: PropTypes.func.isRequired,
    checkedArray: PropTypes.array.isRequired,
    clearUseCasesFunction: PropTypes.func.isRequired,
    closeDialogFunction: PropTypes.func.isRequired,
    createOrderFunction: PropTypes.func.isRequired,
    dataSets: PropTypes.object.isRequired,
    dialog: PropTypes.object.isRequired,
    dirty: PropTypes.bool.isRequired,
    escapeForm: PropTypes.func.isRequired,
    fetchFieldsetsByIdFunction: PropTypes.func.isRequired,
    fieldSets: PropTypes.object.isRequired,
    formValues: PropTypes.object,
    getPriceBookFunction: PropTypes.func.isRequired,
    getRevShareFunction: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    invalid: PropTypes.bool.isRequired,
    isSuperAdmin: PropTypes.bool.isRequired,
    nextPageFunction: PropTypes.func.isRequired,
    openDialogFunction: PropTypes.func.isRequired,
    page: PropTypes.string.isRequired,
    platformMap: PropTypes.object.isRequired,
    previousPageFunction: PropTypes.func.isRequired,
    priceBook: PropTypes.object.isRequired,
    renderCompanyInfo: PropTypes.func.isRequired,
    renderOrderSummaryChunk: PropTypes.func.isRequired,
    submitting: PropTypes.bool.isRequired,
    useCaseMap: PropTypes.object.isRequired,
  };

  static defaultProps = {
    formValues: undefined,
  };

  toggleDialog = id => {
    const { dialog, openDialogFunction, closeDialogFunction } = this.props;
    if (dialog.show && (dialog.id === 'confirmOrderDialog' || 'confirmOrderDialog')) {
      closeDialogFunction(id);
    } else {
      openDialogFunction(id, 1);
    }
  };

  cancelDialog = id => {
    const { closeDialogFunction } = this.props;
    closeDialogFunction(id);
  };

  render() {
    const {
      account,
      accountId,
      accountSettings,
      addToListFunction,
      cancelOrderFunction,
      change,
      checkedArray,
      clearUseCasesFunction,
      createOrderFunction,
      dataSets,
      dialog,
      dirty,
      escapeForm,
      fetchFieldsetsByIdFunction,
      fieldSets,
      formValues,
      getPriceBookFunction,
      getRevShareFunction,
      handleSubmit,
      invalid,
      isSuperAdmin,
      nextPageFunction,
      platformMap,
      previousPageFunction,
      priceBook,
      renderCompanyInfo,
      renderOrderSummaryChunk,
      submitting,
      useCaseMap,
    } = this.props;
    const page = parseInt(this.props.page, 10);

    return (
      <div className="new-order-wizard">
        {page === 1 ? (
          <NewOrderFormOne
            dirty={dirty}
            invalid={invalid}
            cancelOrderFunction={cancelOrderFunction}
            escapeForm={escapeForm}
            submitting={submitting}
            submitFunction={nextPageFunction}
          />
        ) : null}
        {page === 2 && formValues !== undefined ? (
          <NewOrderFormTwo
            escapeForm={escapeForm}
            invalid={invalid}
            renderCompanyInfo={renderCompanyInfo}
            cancelOrderFunction={cancelOrderFunction}
            submitFunction={nextPageFunction}
            submitting={submitting}
            previousPageFunction={previousPageFunction}
          />
        ) : null}
        {page === 3 && formValues !== undefined ? (
          <NewOrderFormThree
            addToListFunction={addToListFunction}
            cancelOrderFunction={cancelOrderFunction}
            change={change}
            checkedArray={checkedArray}
            clearUseCasesFunction={clearUseCasesFunction}
            dataSets={dataSets}
            escapeForm={escapeForm}
            fetchFieldsetsByIdFunction={fetchFieldsetsByIdFunction}
            fieldSets={fieldSets}
            formValues={formValues}
            handleSubmit={handleSubmit}
            invalid={invalid}
            platformMap={platformMap}
            previousPageFunction={previousPageFunction}
            renderCompanyInfo={renderCompanyInfo}
            submitFunction={nextPageFunction}
            submitting={submitting}
            useCaseMap={useCaseMap}
          />
        ) : null}
        {page === 4 && formValues !== undefined ? (
          <NewOrderFormFour
            accountId={accountId}
            change={change}
            closeDialogFunction={this.cancelDialog}
            dialog={dialog}
            escapeForm={escapeForm}
            formValues={formValues}
            handleSubmit={handleSubmit}
            invalid={invalid}
            isSuperAdmin={isSuperAdmin}
            openDialogFunction={this.toggleDialog}
            previousPageFunction={previousPageFunction}
            renderCompanyInfo={renderCompanyInfo}
            submitFunction={nextPageFunction}
            submitting={submitting}
          />
        ) : null}
        {page === 5 && formValues !== undefined ? (
          <NewOrderFormFive
            accountId={accountId}
            accountSettings={accountSettings}
            cancelOrderFunction={cancelOrderFunction}
            change={change}
            closeDialogFunction={this.cancelDialog}
            createOrderFunction={createOrderFunction}
            dialog={dialog}
            escapeForm={escapeForm}
            formValues={formValues}
            getPriceBookFunction={getPriceBookFunction}
            getRevShareFunction={getRevShareFunction}
            handleSubmit={handleSubmit}
            invalid={invalid}
            creditsEnabled={account.get('creditsEnabled')}
            openDialogFunction={this.toggleDialog}
            platformMap={platformMap}
            previousPageFunction={previousPageFunction}
            priceBook={priceBook}
            renderCompanyInfo={renderCompanyInfo}
            renderOrderSummaryChunk={renderOrderSummaryChunk}
            submitting={submitting}
            useCaseMap={useCaseMap}
          />
        ) : null}
      </div>
    );
  }
}
